import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule} from '@angular/material/table';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatChipsModule} from '@angular/material/chips';
import {MatRadioModule} from '@angular/material/radio';

import { DataService } from './services/data/data.service';

import { SharedModule } from './components/shared/shared.module';
import { StartStepComponent } from './components/start-step/start-step.component';
import { PrimaryUseStepComponent } from './components/primary-use-step/primary-use-step.component';
import { NeedToRunStepComponent } from './components/need-to-run-step/need-to-run-step.component';
import { BrandsStepComponent } from './components/brands-step/brands-step.component';
import { ResultsStepComponent } from './components/results-step/results-step.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireRemoteConfigModule, DEFAULTS, SETTINGS } from '@angular/fire/remote-config';
import { AngularFireAnalyticsModule, ScreenTrackingService, CONFIG } from '@angular/fire/analytics';
import { AngularFirePerformanceModule, PerformanceMonitoringService } from '@angular/fire/performance';
import { environment } from './../environments/environment';
import { UseCaseStepComponent } from './components/use-case-step/use-case-step.component';
import { SelectionsComponent } from './components/results-step/sections/selections/selections.component';
import { IdealUseCaseComponent } from './components/results-step/sections/ideal-use-case/ideal-use-case.component';
import { FormFactorsFiltersComponent } from './components/results-step/sections/form-factors-filters/form-factors-filters.component';
import { ScreenSizeFiltersComponent } from './components/results-step/sections/screen-size-filters/screen-size-filters.component';
import { BrandFiltersComponent } from './components/results-step/sections/brand-filters/brand-filters.component';
import { DeviceResultComponent } from './components/results-step/sections/device-result/device-result.component';
import { ShareResultsDialogComponent } from './components/results-step/sections/share-results-dialog/share-results-dialog.component';
import { isDevMode } from '@angular/core';
import { DataFactoryService } from './services/data/data-factory.service';
import { ResultsConfigComponent } from './components/admin/results-config/results-config.component';
import { PERSISTENCE } from '@angular/fire/auth';
import { StorageFiltersComponent } from './components/results-step/sections/storage-filters/storage-filters.component';
import { FeatureFiltersComponent } from './components/results-step/sections/feature-filters/feature-filters.component';
import { DeviceInfoComponent } from './components/results-step/sections/device-result/device-info/device-info.component';
import { OsTypeFiltersComponent } from './components/results-step/sections/os-type-filters/os-type-filters.component';
import { FilterChipsComponent } from './components/results-step/sections/filter-chips/filter-chips.component';
import { PriceSortingComponent } from './components/results-step/sections/price-sorting/price-sorting.component';
import { AueLinkComponent } from './components/results-step/sections/aue-link/aue-link.component';

@NgModule({
  declarations: [
    AppComponent,
    StartStepComponent,
    PrimaryUseStepComponent,
    NeedToRunStepComponent,
    BrandsStepComponent,
    ResultsStepComponent,
    UseCaseStepComponent,
    SelectionsComponent,
    IdealUseCaseComponent,
    FormFactorsFiltersComponent,
    ScreenSizeFiltersComponent,
    BrandFiltersComponent,
    DeviceResultComponent,
    ShareResultsDialogComponent,
    ResultsConfigComponent,
    StorageFiltersComponent,
    FeatureFiltersComponent,
    DeviceInfoComponent,
    OsTypeFiltersComponent,
    FilterChipsComponent,
    PriceSortingComponent,
    AueLinkComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SharedModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireRemoteConfigModule,
    AngularFireAnalyticsModule,
    AngularFirePerformanceModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatExpansionModule,
    MatChipsModule,
    MatRadioModule
  ],
  providers: [
    { provide: DEFAULTS, useValue: {  } },
    {
      provide: SETTINGS,
      useFactory: () => isDevMode() ? { minimumFetchIntervalMillis: 10_000 } : {}
    },
    { provide: PERSISTENCE, useValue: 'session' },
    { provide: CONFIG, useValue: {
      cookie_flags: 'secure;samesite=none'
    } },
    // {provide: MAT_RADIO_DEFAULT_OPTIONS,
    // useValue: { color: 'accent' }},
    ScreenTrackingService,
    PerformanceMonitoringService,
    {provide: DataService, deps: [DataFactoryService], useFactory: (dataFactoryService: DataFactoryService) => dataFactoryService.getDataService()}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
